import React from "react";
import "./AnimatedFlow.css";

function AnimatedFlow() {
  return (
    <div className="animated-flow-container">
      <svg
        viewBox="0 0 1100 450"
        className="animated-flow-svg"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Chat Message / Badminton Booking (Left) */}
        <g className="image-icon">
          {/* Phone screen background */}
          <rect
            x="30"
            y="60"
            width="400"
            height="250"
            rx="16"
            fill="#F3F4F6"
            stroke="#D1D5DB"
            strokeWidth="4"
          />

          {/* Event 1: Badminton Booking Confirmation */}
          <g className="event-cycle event-1">
            {/* Opaque background to hide other cycling elements */}
            <rect
              x="30"
              y="60"
              width="400"
              height="250"
              rx="16"
              fill="#F3F4F6"
            />
            {/* Email/Booking header */}
            <rect
              x="50"
              y="75"
              width="360"
              height="35"
              rx="8"
              fill="#DBEAFE"
            />
            <text x="65" y="97" fontSize="14" fontWeight="700" fill="#1F2937">
              Booking Confirmation
            </text>
            <text x="280" y="97" fontSize="12" fill="#6B7280">
              #BCF-4521
            </text>

            {/* From line */}
            <text x="65" y="125" fontSize="13" fill="#6B7280">
              From: Sports Center Badminton
            </text>

            {/* Confirmation details */}
            <text x="65" y="150" fontSize="15" fontWeight="600" fill="#1F2937">
              Court 3 Reserved
            </text>

            <text x="65" y="175" fontSize="14" fill="#4B5563">
              Date: Tomorrow, Jan 15
            </text>

            <text x="65" y="195" fontSize="14" fill="#4B5563">
              Time: 2:00 PM - 3:00 PM
            </text>

            <text x="65" y="215" fontSize="14" fill="#4B5563">
              Location: Sports Center Court 3
            </text>

            {/* Confirmation note */}
            <text x="65" y="240" fontSize="13" fill="#059669" fontWeight="600">
              ✓ Confirmed - Paid
            </text>

            <text x="65" y="260" fontSize="12" fill="#9CA3AF">
              Please arrive 10 minutes early
            </text>
          </g>

          {/* Event 2: Meeting Chat */}
          <g className="event-cycle event-2">
            {/* Opaque background to hide other cycling elements */}
            <rect
              x="30"
              y="60"
              width="400"
              height="250"
              rx="16"
              fill="#F3F4F6"
            />
            {/* Chat header */}
            <rect
              x="30"
              y="60"
              width="400"
              height="40"
              rx="16"
              fill="#F59E0B"
            />
            <circle cx="60" cy="80" r="12" fill="white" />
            <text x="80" y="86" fontSize="16" fontWeight="600" fill="white">
              Team Channel
            </text>

            {/* Message bubble 1 */}
            <rect
              x="50"
              y="115"
              width="320"
              height="38"
              rx="18"
              fill="white"
              stroke="#E5E7EB"
              strokeWidth="2"
            />
            <text x="65" y="135" fontSize="15" fill="#1F2937">
              Reminder: Daily standup tomorrow
            </text>
            <text x="65" y="147" fontSize="15" fill="#1F2937">
              Monday at 9 AM via video call
            </text>

            {/* Message bubble 2 */}
            <rect
              x="50"
              y="165"
              width="280"
              height="25"
              rx="12"
              fill="white"
              stroke="#E5E7EB"
              strokeWidth="2"
            />
            <text x="65" y="182" fontSize="15" fill="#1F2937">
              Please be on time everyone!
            </text>

            {/* Reactions */}
            <text x="60" y="210" fontSize="20">
              👍
            </text>
            <text x="85" y="210" fontSize="20">
              ✅
            </text>

            {/* Timestamp */}
            <text x="370" y="267" fontSize="12" fill="#9CA3AF">
              Yesterday
            </text>
          </g>

          {/* Event 3: Restaurant Booking Screenshot */}
          <g className="event-cycle event-3">
            {/* Opaque background to hide other cycling elements */}
            <rect
              x="30"
              y="60"
              width="400"
              height="250"
              rx="16"
              fill="#F3F4F6"
            />
            {/* App header */}
            <rect
              x="30"
              y="60"
              width="400"
              height="40"
              rx="16"
              fill="#10B981"
            />
            <text x="200" y="86" fontSize="16" fontWeight="600" fill="white" textAnchor="middle">
              OpenTable
            </text>

            {/* Restaurant name */}
            <text x="230" y="125" fontSize="18" fontWeight="700" fill="#1F2937" textAnchor="middle">
              La Bella Vita
            </text>

            {/* Booking details box */}
            <rect
              x="60"
              y="140"
              width="310"
              height="105"
              rx="12"
              fill="#DCFCE7"
              stroke="#10B981"
              strokeWidth="2"
            />

            <text x="80" y="165" fontSize="15" fontWeight="600" fill="#1F2937">
              Reservation Confirmed
            </text>

            <text x="80" y="188" fontSize="14" fill="#4B5563">
              Party of 4
            </text>

            <text x="80" y="208" fontSize="14" fill="#4B5563">
              Saturday, 7:30 PM
            </text>

            <text x="80" y="228" fontSize="14" fill="#4B5563">
              123 Main Street, Downtown
            </text>

            {/* Confirmation code */}
            <text x="230" y="270" fontSize="12" fill="#9CA3AF" textAnchor="middle">
              Confirmation: RES-8832
            </text>
          </g>

          {/* Image label */}
          <text
            x="230"
            y="360"
            textAnchor="middle"
            className="flow-label"
            fill="#4B5563"
            fontSize="18"
          >
            Upload Image
          </text>
        </g>

        {/* Animated Arrows (Center) */}
        <g className="arrow-group">
          {/* Arrow 1 */}
          <g className="arrow arrow-1">
            <line
              x1="450"
              y1="150"
              x2="560"
              y2="150"
              stroke="#8B5CF6"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <polygon points="560,150 540,140 540,160" fill="#8B5CF6" />
          </g>

          {/* Arrow 2 */}
          <g className="arrow arrow-2">
            <line
              x1="470"
              y1="185"
              x2="580"
              y2="185"
              stroke="#8B5CF6"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <polygon points="580,185 560,175 560,195" fill="#8B5CF6" />
          </g>

          {/* Arrow 3 */}
          <g className="arrow arrow-3">
            <line
              x1="450"
              y1="220"
              x2="560"
              y2="220"
              stroke="#8B5CF6"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <polygon points="560,220 540,210 540,230" fill="#8B5CF6" />
          </g>

          {/* AI Sparkles - More magical stars */}
          <g className="sparkle sparkle-1">
            <path
              d="M 490 100 L 495 115 L 510 120 L 495 125 L 490 140 L 485 125 L 470 120 L 485 115 Z"
              fill="#F59E0B"
            />
          </g>
          <g className="sparkle sparkle-2">
            <path
              d="M 530 270 L 535 285 L 550 290 L 535 295 L 530 310 L 525 295 L 510 290 L 525 285 Z"
              fill="#F59E0B"
            />
          </g>
          <g className="sparkle sparkle-3">
            <path
              d="M 440 80 L 445 95 L 460 100 L 445 105 L 440 120 L 435 105 L 420 100 L 435 95 Z"
              fill="#F59E0B"
            />
          </g>
          <g className="sparkle sparkle-4">
            <path
              d="M 550 130 L 554 142 L 566 146 L 554 150 L 550 162 L 546 150 L 534 146 L 546 142 Z"
              fill="#8B5CF6"
            />
          </g>
          <g className="sparkle sparkle-5">
            <path
              d="M 460 175 L 464 187 L 476 191 L 464 195 L 460 207 L 456 195 L 444 191 L 456 187 Z"
              fill="#8B5CF6"
            />
          </g>
          <g className="sparkle sparkle-6">
            <path
              d="M 510 70 L 514 80 L 524 84 L 514 88 L 510 98 L 506 88 L 496 84 L 506 80 Z"
              fill="#EC4899"
            />
          </g>
          <g className="sparkle sparkle-7">
            <path
              d="M 570 120 L 574 130 L 584 134 L 574 138 L 570 148 L 566 138 L 556 134 L 566 130 Z"
              fill="#EC4899"
            />
          </g>
          <g className="sparkle sparkle-8">
            <path
              d="M 460 250 L 464 260 L 474 264 L 464 268 L 460 278 L 456 268 L 446 264 L 456 260 Z"
              fill="#10B981"
            />
          </g>
          <g className="sparkle sparkle-9">
            <path
              d="M 555 250 L 560 265 L 575 270 L 560 275 L 555 290 L 550 275 L 535 270 L 550 265 Z"
              fill="#10B981"
            />
          </g>
          <g className="sparkle sparkle-10">
            <path
              d="M 530 90 L 534 100 L 544 104 L 534 108 L 530 118 L 526 108 L 516 104 L 526 100 Z"
              fill="#F59E0B"
            />
          </g>
        </g>

        {/* Calendar Event Card (Right) */}
        <g className="calendar-card">
          {/* Card background */}
          <rect
            x="580"
            y="60"
            width="420"
            height="250"
            rx="16"
            fill="white"
            stroke="#3B82F6"
            strokeWidth="4"
          />

          {/* Calendar Event 1: Badminton Game */}
          <g className="calendar-event-cycle calendar-event-1">
            {/* Opaque background to hide other cycling elements */}
            <rect
              x="580"
              y="60"
              width="420"
              height="250"
              rx="16"
              fill="white"
            />
            <rect
              x="580"
              y="60"
              width="12"
              height="250"
              rx="16"
              fill="#3B82F6"
            />
            <text
              x="610"
              y="110"
              className="event-title"
              fill="#1F2937"
              fontWeight="600"
              fontSize="26"
            >
              Badminton Game
            </text>
            <circle
              cx="610"
              cy="155"
              r="12"
              fill="none"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="610"
              y1="155"
              x2="610"
              y2="148"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="610"
              y1="155"
              x2="616"
              y2="155"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <text
              x="632"
              y="162"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              2:00 PM - 3:00 PM
            </text>
            <rect
              x="605"
              y="190"
              width="24"
              height="22"
              rx="3"
              fill="none"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="605"
              y1="198"
              x2="629"
              y2="198"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="613"
              y1="187"
              x2="613"
              y2="193"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="621"
              y1="187"
              x2="621"
              y2="193"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <text
              x="638"
              y="207"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              Tomorrow
            </text>
            <path
              d="M 610 247 C 610 243 613 240 617 240 C 621 240 624 243 624 247 C 624 251 617 257 617 257 C 617 257 610 251 610 247 Z"
              fill="#6B7280"
            />
            <text
              x="638"
              y="254"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              Sports Center Court 3
            </text>
            <g transform="translate(945, 270)">
              <rect x="0" y="0" width="42" height="42" rx="4" fill="#4285F4" />
              <text
                x="21"
                y="30"
                textAnchor="middle"
                fill="white"
                fontSize="26"
                fontWeight="bold"
              >
                15
              </text>
            </g>
          </g>

          {/* Calendar Event 2: Team Standup */}
          <g className="calendar-event-cycle calendar-event-2">
            {/* Opaque background to hide other cycling elements */}
            <rect
              x="580"
              y="60"
              width="420"
              height="250"
              rx="16"
              fill="white"
            />
            <rect
              x="580"
              y="60"
              width="12"
              height="250"
              rx="16"
              fill="#F59E0B"
            />
            <text
              x="610"
              y="110"
              className="event-title"
              fill="#1F2937"
              fontWeight="600"
              fontSize="26"
            >
              Team Standup
            </text>
            <circle
              cx="610"
              cy="155"
              r="12"
              fill="none"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="610"
              y1="155"
              x2="610"
              y2="148"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="610"
              y1="155"
              x2="616"
              y2="155"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <text
              x="632"
              y="162"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              9:00 AM - 9:30 AM
            </text>
            <rect
              x="605"
              y="190"
              width="24"
              height="22"
              rx="3"
              fill="none"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="605"
              y1="198"
              x2="629"
              y2="198"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="613"
              y1="187"
              x2="613"
              y2="193"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="621"
              y1="187"
              x2="621"
              y2="193"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <text
              x="638"
              y="207"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              Monday
            </text>
            <path
              d="M 610 247 C 610 243 613 240 617 240 C 621 240 624 243 624 247 C 624 251 617 257 617 257 C 617 257 610 251 610 247 Z"
              fill="#6B7280"
            />
            <text
              x="638"
              y="254"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              Video Conference
            </text>
            <g transform="translate(945, 270)">
              <rect x="0" y="0" width="42" height="42" rx="4" fill="#4285F4" />
              <text
                x="21"
                y="30"
                textAnchor="middle"
                fill="white"
                fontSize="26"
                fontWeight="bold"
              >
                6
              </text>
            </g>
          </g>

          {/* Calendar Event 3: Restaurant Reservation */}
          <g className="calendar-event-cycle calendar-event-3">
            {/* Opaque background to hide other cycling elements */}
            <rect
              x="580"
              y="60"
              width="420"
              height="250"
              rx="16"
              fill="white"
            />
            <rect
              x="580"
              y="60"
              width="12"
              height="250"
              rx="16"
              fill="#10B981"
            />
            <text
              x="610"
              y="110"
              className="event-title"
              fill="#1F2937"
              fontWeight="600"
              fontSize="26"
            >
              La Bella Vita
            </text>
            <circle
              cx="610"
              cy="155"
              r="12"
              fill="none"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="610"
              y1="155"
              x2="610"
              y2="148"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="610"
              y1="155"
              x2="616"
              y2="155"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <text
              x="632"
              y="162"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              7:30 PM - 9:00 PM
            </text>
            <rect
              x="605"
              y="190"
              width="24"
              height="22"
              rx="3"
              fill="none"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="605"
              y1="198"
              x2="629"
              y2="198"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="613"
              y1="187"
              x2="613"
              y2="193"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <line
              x1="621"
              y1="187"
              x2="621"
              y2="193"
              stroke="#6B7280"
              strokeWidth="3"
            />
            <text
              x="638"
              y="207"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              Saturday
            </text>
            <path
              d="M 610 247 C 610 243 613 240 617 240 C 621 240 624 243 624 247 C 624 251 617 257 617 257 C 617 257 610 251 610 247 Z"
              fill="#6B7280"
            />
            <text
              x="638"
              y="254"
              className="event-detail"
              fill="#6B7280"
              fontSize="19"
            >
              123 Main Street, Downtown
            </text>
            <g transform="translate(945, 270)">
              <rect x="0" y="0" width="42" height="42" rx="4" fill="#4285F4" />
              <text
                x="21"
                y="30"
                textAnchor="middle"
                fill="white"
                fontSize="26"
                fontWeight="bold"
              >
                10
              </text>
            </g>
          </g>

          {/* Calendar label */}
          <text
            x="790"
            y="360"
            textAnchor="middle"
            className="flow-label"
            fill="#4B5563"
            fontSize="18"
          >
            Google Calendar
          </text>
        </g>
      </svg>
    </div>
  );
}

export default AnimatedFlow;
